<template>
  <tfoot>
    <tr>
      <td colspan="20">
        <ul class="pager">
          <li :class="{disabled: !form.showPreviousPager}"><a class="pointer" v-on:click.prevent="previous">Previous</a></li>
          <li :class="{disabled: !form.showNextPager}"><a class="pointer" v-on:click.prevent="next">Next</a></li>
        </ul>
      </td>
    </tr>
  </tfoot>
</template>

<script>

  export default {
    name: 'pager',

    props: ['form'],

    methods: {
      previous() {
        if (this.$props.form.showPreviousPager) {
          this.$props.form.previousPage();
        }
      },
      next() {
        if (this.$props.form.showNextPager) {
          this.$props.form.nextPage();
        }
      },
    }

  }

</script>